import { Button } from 'primereact/button'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import styled from 'styled-components'

/* ############### "MeetingRoomList" Components ############### */

export const Divider = styled.div`
  border: 1px solid #cecece;
`
export const Line = styled.span`
  font-size: 1.3rem;
  color: #9d9d9d;

  @media (max-width: 1400px) {
    display: none;
  }
`
export const FormLayoutWrapper = styled.div`
  display: flex;
  width: 100%;
  //   justify-content: space-between;
  // flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-top: 22px;
  margin-bottom: 1rem;
  padding: 0 0.5rem;
`
export const RoomCardList = styled.div`
  display: flex;
  max-height: 700px;
  overflow-y: auto;
  padding: 1rem 0.25rem 0.25rem;
  // justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 16px;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
    background-color: #d3d3d3 !important;
    border-radius: 10px;
  }

  &::-webkit-scrollbar {
    height: 6px;
    width: 6px !important;
    background-color: #d3d3d3;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #7c7c7c;
    border-radius: 10px;
  }
`
/* ############### "MeetingRoomSearch" Components ############### */

export const InputWrapper = styled.span`
  position: relative;
  display: inline-block;

  .input-icon {
    left: 0.5rem;
    color: #6c757d;
    position: absolute;
    top: 50%;
    margin-top: -10px;
  }
`
export const StyledInputText = styled(InputText)`
  width: 100%;
  min-width: 300px;
  border-radius: 10px;
  height: 50px;
  color: #363636;
  font-size: 14px;
  line-height: 16.71px;
  font-family: 'Inter', serif !important;
  font-weight: 500;
  padding-right: 16px;

  @media (max-width: 1200px) {
    min-width: 220px;
  }
`
/* ############### "MeetingRoomFilterForm" Components ############### */

export const ResetButton = styled(Button)`
  width: 135px;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;

  :disabled {
    opacity: 0.4;
  }
`
export const FilterButton = styled(Button)`
  width: 135px;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;
`
export const DropdownWrapper = styled.div`
  position: relative;
  .autocomplete-title {
    position: absolute;
    left: 35px;
  }

  .autocomplete-icon {
    position: absolute;
    left: 8px;
    top: 16px;
    z-index: 1;
    color: #a8a8a8;
  }

  .selectedVal,
  .p-dropdown .p-dropdown-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .selectedVal {
    margin-top: 0.5rem;
    font-weight: 700;
  }

  .p-dropdown .p-dropdown-label {
    padding-left: 2rem;
    padding-right: 0;
  }
`
export const StyledDropdown = styled(Dropdown)`
  width: 100%;
  width: 400px;
  height: 50px;
  border-radius: 10px;
  align-items: center;

  .p-dropdown-panel {
    z-index: 1004 !important;
    position: absolute !important;
    left: 0px !important;
    top: 52px !important;
    min-width: 100% !important;
    min-height: 100% !important;
    background: #ffffff !important;
    transform-origin: center top !important;
  }

  .p-dropdown-items-wrapper {
    max-height: 250px !important;
  }

  @media (max-width: 1200px) {
    width: 16rem;
  }
`
export const DatePickerWrapper = styled.div`
  width: 160px;
`
/* ############### "MeetingRoomCard" Components ############### */

export const StyledCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 300px;
  max-width: 300px;
  height: 330px;
  padding: 0 0 1rem;
  background: #ffffff;
  border: 1px solid #cecece;
  border-radius: 8px;
`
export const CardHeaderOverlay = styled.div`
  position: relative;
  width: 300px;
  max-width: 300px;
  height: 20px;
  // min-height: 48px;
  background: #ffdce8;
  border-radius: 8px 8px 0px 0px;
  margin-bottom: 10px;
`

export const FavoriteContainer = styled.div`
  position: absolute;
  top: 6px;
  right: 12px;
`

export const RoomName = styled.span`
  color: #354147;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  height: 38px;
  color: #354147;
  margin-bottom: 8px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`
export const RoomLocation = styled.span`
  line-height: 14px;
  font-size: 13px;
  height: 30px;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const RoomCapacity = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.25rem;
  margin-top: 0.5rem;

  span {
    font-size: 12px;
    letter-spacing: 0.04rem;
    font-weight: 400;
  }
`

export const Summary = styled.span`
  margin-top: 8px;
  max-height: 100px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #646464;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`

export const CardImgPreview = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  cursor: pointer;

  i.pi-image {
    color: #45bfe5;
  }

  span {
    color: #45bfe5;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
`

export const ImgPreviewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0.5rem;
  width: 100%;
  height: 100%;
`

export const WorkingHours = styled.div`
  margin: 10px 0;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: #354147;

  span.wh-title {
    font-weight: 700;
  }
`
export const ReservationButton = styled(Button)`
  width: 230px;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;
`

/* Sidebar - Schedule */
export const InfoListItem = styled.div`
  display: flex;
  align-items: ${({ hasList }: { hasList: boolean }) => (hasList ? 'flex-start' : 'center')};
  justify-content: flex-start;
  gap: 10px;
  font-size: 14px;
  line-height: 17px;

  img {
    width: 20px;
    height: 20px;
  }

  .reservation-info-title {
    font-weight: 700;
    white-space: nowrap;
  }

  .reservation-info-value {
    word-break: break-words;
    word-wrap: break-word;
  }
`
